<template>
  <div id="AssingGrid">
    <vue-bootstrap4-table
      :rows="this.DataRowGrid"
      :columns="this.DatacolumnsGrid"
      :config="config"
      :classes="classes"
      @on-select-row="selectItem(rows)"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>

      <template slot="action-slot" slot-scope="props">
        <a href="#" class="mr-2 badge" @click="OnDelete(props.row)"
          ><span class="fa fa-remove text-danger" style="font-size: 20px"></span
        ></a>
        <a
          href="#"
          class="mr-2 badge"
          @click="OnEdit(props.row)"
          data-toggle="modal"
          data-target="#openModal"
          ><span
            class="fa fa-pencil text-success"
            style="font-size: 20px"
          ></span
        ></a>
      </template>
      <template slot="DeleteMode-slot" slot-scope="props" class="text-center">
        <a href="#" class="mr-2 badge" @click="OnDelete(props.row)"
          ><span class="fa fa-remove text-danger" style="font-size: 20px"></span
        ></a>
      </template>
      <template slot="EditMode-slot" slot-scope="props" class="text-center">
        <a href="#" class="mr-2 badge" @click="OnEditSingle(props.row)"
          ><span
            class="fas fa-pencil-alt text-success"
            style="font-size: 20px"
          ></span
        ></a>
      </template>
      <template slot="Asli" slot-scope="props" class="text-center">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input InputText"
            :checked="props.cell_value"
            id="checkTest"
            disabled
          />
          <label class="custom-control-label" for="checkTest"></label>
        </div>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
export default {
  data() {
    return {
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      DataAxiosDelete: {
        ArryfildValue: "",
        Method: "Delete",
        Action: this.$route.name,
        Token: this.$session.get("Token"),
      },
      classes: { table: "table-bordered table-striped table-sm" },
    };
  },
  mounted() {
    this.$store.state.TarifKarbaran.EditMode = false;
  },
  components: { VueBootstrap4Table },
  props: ["DataRowGrid", "DatacolumnsGrid"],
  methods: {
    OnDelete(row) {
      if (this.$route.name == "TarifSematha") {
        this.DataAxiosDelete.Action = "DastresiDB";
      }
      this.DataAxiosDelete.ArryfildValue = { id: row.Id };
      this.$DeleteData(this.DataAxiosDelete, this.Sweet);
    },
    OnEditSingle(data) {
      if (this.$route.name == "DetailTarifKarbaran") {
        if (this.$store.state.TarifKarbaran.EditMode == false) {
          this.$store.state.TarifKarbaran.EditDataUserGrp = data;
          if (data.Asli === true) {
            this.$store.state.TarifKarbaran.EditDataUserGrp.Asli = true;
          } else {
            this.$store.state.TarifKarbaran.EditDataUserGrp.Asli = false;
          }
          this.$store.state.TarifKarbaran.EditMode =
            !this.$store.state.TarifKarbaran.EditMode;
        } else {
          this.$SweetQustion(
            "لغو عملیات ویرایش",
            "مایل به لغو عملیات ویرایشی که هم اکنون درحال تغییر آن می باشید هستید؟",
            "warning",
            "ادامه ویرایش",
            "لغو ویرایش",
            null,
            this.Edit,
            this.CancelEdit
          );
        }
      }
    },
    CancelEdit() {
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
      this.$store.state.TarifKarbaran.EditMode =
        !this.$store.state.TarifKarbaran.EditMode;
    },
    Edit() {},
  },
};
</script>
<style scoped></style>
